









































import { Component, Vue } from 'vue-property-decorator';
import NavDrawer from '@/components/NavDrawer.vue'
import { handle } from '@/utils/ErrorHandling'
import { safeRoutes } from '@/router/index'
import BaseSnackbar from '@/components/BaseSnackbar.vue'

@Component({
  components: {
    NavDrawer,
    BaseSnackbar,
  }
})
export default class App extends Vue {
  drawer = true

  mounted () {
    const routeName = this.$route.name as string
    if (safeRoutes.includes(routeName)) {
      return
    }
    this.$store.dispatch('setCurrentUser').catch(handle)
  }

  get alertShow () {
    return this.$store.state.alert.show
  }

  set alertShow (show: boolean) {
    if (!show) {
      this.$store.dispatch('discardMessage')
    }
  }

  get alertMessage () {
    return this.$store.state.alert.message
  }

  get alertColor () {
    return this.$store.state.alert.color
  }

  get user () {
    return this.$store.state.user.currentUser
  }
}
